
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { login } from '../reducers';

import DrawerMenu from '../components/DrawerMenu';

/**
 * Account page containers
 * Receives userId, loads products list, account, licences and invitations
 */

const mapStateToProps = (state) => {
    const {
        productsById,
        accountsByUserId,
        currentProduct,
    } = state; 

  const user = login(state);
  const account = accountsByUserId[user.id];
  const allProducts = Object.values(productsById);

  const subscriptions = (account && account.subscriptions) || [];     
  const products = (
    allProducts 
    && allProducts.filter( product => 
        !subscriptions.find( s => 
            s.plan.product.id === product.id ))
  ) || [];

  return {
    user,
    products,
    subscriptions,
    currentProduct,
  };
}


const DrawerMenuContainer = withRouter(
  connect(
    mapStateToProps
  )(DrawerMenu)
);

export default DrawerMenuContainer;


// WEBPACK FOOTER //
// ./src/containers/DrawerMenu.js